import React, { useRef, useEffect } from 'react'
import { Button, Input } from 'antd'
import { Pencil } from 'lucide-react'
import type { LineItem } from '../../types/ffe'

interface Props {
  item: LineItem
  onUpdate: (updates: Partial<LineItem>) => void
}

export const LineItemDescription: React.FC<Props> = ({ item, onUpdate }) => {
  const [isEditing, setIsEditing] = React.useState(false)
  const [tempValue, setTempValue] = React.useState(item.description)
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (isEditing && textAreaRef.current) {
      textAreaRef.current.focus()
    }
  }, [isEditing])

  useEffect(() => {
    setTempValue(item.description)
  }, [item.description])

  const handleSubmit = () => {
    onUpdate({ description: tempValue })
    setIsEditing(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      setTempValue(item.description)
      setIsEditing(false)
    }
  }

  if (isEditing) {
    return (
      <Input.TextArea
        ref={textAreaRef}
        value={tempValue}
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleSubmit}
        onKeyDown={handleKeyDown}
        placeholder="Add description"
        autoSize={{ minRows: 2, maxRows: 6 }}
        className="text-gray-600"
      />
    )
  }

  return (
    <Button
      type="text"
      className="w-full !justify-start h-auto py-1 px-2 hover:bg-gray-100"
      onClick={() => setIsEditing(true)}
    >
      <div className="flex items-center gap-2 w-full">
        <span
          className="flex-1 text-left text-gray-600"
          style={{
            justifyContent: 'flex-start',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}
        >
          {item.description ? (
            <span className="text-wrap">{item.description}</span>
          ) : (
            <span className="text-gray-400">Add description</span>
          )}
          <Pencil className="h-3 w-3 text-gray-400 min-w-[13px]" />
        </span>
      </div>
    </Button>
  )
}
